import axios from 'axios';

let controller;

export async function getIsCodenummerUnique(apiUrl, plz, commodity) {
  if (controller) controller.abort();
  controller = new AbortController();
  const params = new URLSearchParams();
  params.append('tx_uopreisrechner_preisrechner[plzAndCity]', plz);
  params.append('tx_uopreisrechner_preisrechner[commodity]', commodity);
  const resp = await axios.post(apiUrl, params, {
    signal: controller.signal
  })
  return resp.data.data || [];
}
